// PageVariablesEmpresas.js

export const pageVariables = {
    headers: [
        'DATA GERAÇÃO', 'DATA FECHAMENTO', 'VIGÊNCIA','APÓLICE', 'EMPRESA', 'SITUAÇÃO', 'QTD VIDAS'
    ],
    headerInfo: {
        title: "Movimentações",
        description: "Esta seção fornece informações detalhadas sobre as movimentações de segurados na fatura, registrando inclusões, alterações e cancelamentos vinculados ao período de faturamento. Acompanhe o status de cada movimentação (aberta, prévia ou fechada), as datas de referência e a empresa/apólice associada, garantindo controle, rastreabilidade e consistência antes do fechamento da fatura."
    },

    headersEvento: [
        'DATA GERAÇÃO', 'DATA FECHAMENTO', 'VIGÊNCIA','APÓLICE', 'EMPRESA', 'SITUAÇÃO', 'QTD VIDAS'
    ],
    headerInfoEventos: {
        title: "Movimentações",
        description: "Esta seção fornece informações detalhadas sobre as movimentações de segurados na fatura, registrando inclusões, alterações e cancelamentos vinculados ao período de faturamento. Acompanhe o status de cada movimentação (aberta, prévia ou fechada), as datas de referência e a empresa/apólice associada, garantindo controle, rastreabilidade e consistência antes do fechamento da fatura."
    },
    page: process.env.VUE_APP_API_URL+"controles",
    searchPage:process.env.VUE_APP_API_URL+"apolices",
    resumoPage:process.env.VUE_APP_API_URL+"controle/resumo",
    eventosPage:process.env.VUE_APP_API_URL+"eventos",
    regrasPage:process.env.VUE_APP_API_URL+"eventos",
    movimentacaoControle:process.env.VUE_APP_API_URL+"movimentacao-controle",
    pageCreateMov:process.env.VUE_APP_API_URL+"movimentacao"
};
